// src/pages/profile-settings/doctor/practiceTeamConstants.js
export const PRACTICE_TEAM_ROLES = [
  {
    value: "practice_assistant",
    labelKey: "settings.practiceTeam.roles.practiceAssistant.label",
    label: "Practice Assistant",
    descriptionKey: "settings.practiceTeam.roles.practiceAssistant.description",
    description: "Helps with day-to-day patient and appointment administration.",
  },
  {
    value: "receptionist",
    labelKey: "settings.practiceTeam.roles.receptionist.label",
    label: "Receptionist",
    descriptionKey: "settings.practiceTeam.roles.receptionist.description",
    description:
      "Includes Practice Assistant permissions, plus bookings, appointment coordination and patient communication.",
  },
  {
    value: "practice_manager",
    labelKey: "settings.practiceTeam.roles.practiceManager.label",
    label: "Practice Manager",
    descriptionKey: "settings.practiceTeam.roles.practiceManager.description",
    description:
      "Includes Receptionist permissions, plus wider practice operations and administrative follow-up.",
  },
  {
    value: "billing_administrator",
    labelKey: "settings.practiceTeam.roles.billingAdministrator.label",
    label: "Billing Administrator",
    descriptionKey: "settings.practiceTeam.roles.billingAdministrator.description",
    description:
      "Includes relevant administration permissions, plus payment follow-up and billing administration.",
  },
];

export const PRACTICE_TEAM_ACTIVE_STATUSES = ["pending_invite", "active"];
